/** The kinds a step can be added as, from the tools at the top of a tree (design study 09, adding A). */

export interface ToolKind {
  kind: string;
  /** Its name on the button. */
  word: string;
  /** How it is said after "Add": "a step", "a decision". */
  as: string;
  mark: 'work' | 'decision' | 'gate' | 'milestone';
}

/** The four kinds the master and a job add (the gate is its mark alone, study 09, gates A). */
export const TOOL_KINDS: ToolKind[] = [
  { kind: 'task', word: 'Work', as: 'work', mark: 'work' },
  { kind: 'decision', word: 'Decision', as: 'a decision', mark: 'decision' },
  { kind: 'gate', word: 'A gate', as: 'a gate', mark: 'gate' },
  { kind: 'milestone', word: 'Milestone', as: 'a milestone', mark: 'milestone' },
];
